export function getStringFromObjectAddress(addressObject, countries = []) {
  if (!addressObject) return '';

  let fullAddress = [];
  fullAddress = [
    ...fullAddress,
    addressObject.line_1,
    addressObject.suburb,
    addressObject.state,
    addressObject.postcode,
  ];

  if (addressObject.country_id || (addressObject.country && addressObject.country.id)) {
    if (countries.length) {
      const countryId = addressObject.country_id || addressObject.country.id;
      countries
        .filter(country => country.id === countryId)
        .forEach(country => { fullAddress = [...fullAddress, country.name] })
    } else if (addressObject.country && addressObject.country.name) {
      fullAddress = [...fullAddress, addressObject.country.name]
    }
  }

  return fullAddress.filter(address => !!address).join(', ');
}

export function resolveAddressMapObjectDefault() {
  return {
    line_1: null,
    suburb: null,
    state: null,
    postcode: null,
    country_id: null,
  }
}

export function convertAddressObjectToMapData(addressObject) {
  return addressObject
}

export function compareTwoAddress(address1, address2) {
  if (!address1 || !address2) {
    return false
  }
  const attributes = ['line_1', 'line_2', 'line_3', 'suburb', 'city', 'postcode', 'state', 'country_id']
  for (const attribute of attributes) {
    if (address1[attribute] !== address2[attribute]) {
      return false
    }
  }
  return true
}

export function parseDataAddressData(modelObject, addressData, countries = []) {
  const unitSeperator = addressData.unit_seperator ? addressData.unit_seperator : '/'
  modelObject.postcode = addressData.postal_code
  modelObject.suburb = addressData.locality 
  modelObject.line_1 = (addressData.unit && addressData.street_number)
    ? `${addressData.unit}${unitSeperator}${addressData.street_number} ${addressData.route}`
    : [addressData.street_number, addressData.route].filter(add => !!add).join(' ')
  modelObject.state = addressData.administrative_area_level_1
  const countryName = addressData.country.toLowerCase().replace(/\s/g, '')
  const country = countries.find((countryItem) => {
    return countryItem.name.toLowerCase().replace(/\s/g, '') === countryName
  })
  if (country) {
    modelObject.country_id = country.id
    modelObject.country = country
  }

  return modelObject
}
 
export function parseUnitStreetAddressData(address) {
  try {
    let unitStreet;
    if ((unitStreet = address.match(/^[uU]nit\s\d+,\s\d+\s(\w|\s)+/))) { // Unit 3, 103 Harris Street
      const [unit, streetWithNumber] = unitStreet[0].split(',')
      const [numberStreet, street] = [streetWithNumber.replace(/\D+/g, ''), streetWithNumber.replace(/\d+/g, '')]
      return { subpremise: unit, street_number: numberStreet, route: street, unit_seperator: ', ' }
    }
    if ((unitStreet = address.match(/^\d+\/\d+\s(\w|\s)*/))) { // 1081/1 Victoria Rd
      const [unitNumber, street] = [unitStreet[0].replace(/[a-zA-Z\s]+/g, ''), unitStreet[0].replace(/(\d|\/)+/g, '')]
      const [unit, numberStreet] = [unitNumber.split('/')[0], unitNumber.split('/')[1]]
      return { subpremise: unit, street_number: numberStreet, route: street, unit_seperator: '/' }
    }
  } catch(e) {
  }
  return { subpremise: null, street_number: null, route: null, unit_seperator: null }
}
